import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { getMeetingTitleByMeeting } from 'app/utils/appHelpers';
import AddUpdateDecisionStatusCard from '../Card/AddUpdateDecisionStatusCard';

function DecisionStatusUpdateDialog({ selectedDecision, open, onClose, afterUpdateFunc

}) {
  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="xl">
      <DialogTitle>
        {getMeetingTitleByMeeting(selectedDecision)}
      </DialogTitle>
      <DialogContent dividers>
        <AddUpdateDecisionStatusCard
          selectedDecision={selectedDecision}
          onClose={onClose}
          afterUpdateFunc={afterUpdateFunc}

        />
      </DialogContent>
      <DialogActions>
      </DialogActions>
    </Dialog>
  );
}
export default DecisionStatusUpdateDialog;
